import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Row, Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import OrganizedUnitSaleOperationModalPage from '../../../containers/masters/OrganizedUnitSaleOperation/OrganizedUnitSaleOperationModalPage'
import InputSelect from '../../commons/form/InputSelect'

class OrganizedUnitSaleOperationMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        organizedUnitId: null,
        saleTypeId: null,
        operationTypeId: null
      }
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchOrganizedUnitSaleOperationList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchOrganizedUnitSaleOperationList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleOrganizedUnitsByOperationTypesChange (organizedUnitId) {
    if (this.state.filter.organizedUnitId !== organizedUnitId) {
      this.setState({ filter: { ...this.state.filter, organizedUnitId } })
    }
  }

  handleSaleTypeOperationChange (saleTypeId) {
    if (this.state.filter.saleTypeId !== saleTypeId) {
      this.setState({ filter: { ...this.state.filter, saleTypeId } })
    }
  }

  handleoperationTypeAllComboChange (operationTypeId) {
    if (this.state.filter.operationTypeId !== operationTypeId) {
      this.setState({ filter: { ...this.state.filter, operationTypeId } })
    }
  }

  search () {
    this.props.actions.fetchOrganizedUnitSaleOperationList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        organizedUnitId: null,
        saleTypeId: null,
        operationTypeId: null
      }
    }, () => { this.search() })
  }

  render () {
    const {
      t, organizedUnitSaleOperationList, pagesCount, organizedUnitSaleOperationsCount, filter,
      combos: { organizedUnitsAllCombo, saleTypeAllCombo, operationTypeAllCombo },
      filter: { page },
      actions: { openOrganizedUnitSaleOperationModal, fetchOrganizedUnitSaleOperationList, deleteOrganizedUnitSaleOperation }
    } = this.props
    const tKey = 'MASTERS.OPERATION_TYPE_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.operationTypeId || this.state.filter.organizedUnitId || this.state.filter.saleTypeId)
    return (
      <div className="admin-wrapper">
        <OrganizedUnitSaleOperationModalPage/>
        <Row className="section-users-header">
          <Col sm={12}>
            <div className="header-panel">
              <h4>{t('MASTERS.OPERATION_TYPES_IN_SALE_TYPES')}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="search-form">
            <span className="title-search"><i className="ico-search" /> {t(`${tKey}SEARCH_TITLE`)}</span>
            <Row>
              <Field
                name="filters.organizedUnitId"
                colSm={3}
                controlLabel={t(`${tKey}NAME_OU`)}
                placeholder={t(`${tKey}NAME_OU`)}
                component={InputSelect}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
                onInputChange={(value) => this.handleOrganizedUnitsByOperationTypesChange(value)}
              />
              <Field
                name="filters.saleTypeId"
                colSm={3}
                controlLabel={t(`${tKey}NAME_SALE_TYPE`)}
                placeholder={t(`${tKey}NAME_SALE_TYPE`)}
                component={InputSelect}
                valueKey="id"
                labelKey="value"
                options={saleTypeAllCombo}
                onInputChange={(value) => this.handleSaleTypeOperationChange(value)}
              />
              <Field
                name="filters.operationTypeId"
                colSm={3}
                controlLabel={t(`${tKey}NAME_TYPE_OPERATION`)}
                placeholder={t(`${tKey}NAME_TYPE_OPERATION`)}
                component={InputSelect}
                valueKey="id"
                labelKey="value"
                options={operationTypeAllCombo}
                onInputChange={(value) => this.handleoperationTypeAllComboChange(value)}
              />
              <Col sm={3} className="btn-wrapper">
                <p></p>
                <Button
                  className={'btn-white btn-icon btn-input btn-white search-button'}
                  style={{ width: '100%' }}
                  onClick={() => this.search()}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'btn-icon btn-input ' + (hasFilters ? 'btn-standard' : 'btn-cancel')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}>
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </Col>
            </Row>
          </div>
        </Row>
        <Col sm={12} className="col-row  section-users-body">
          <Table className="editable-table" hover responsive>
            <thead>
              <tr>
                <th onClick={() => { this.changeOrder('organizedUnitId') }}>
                  {t(`${tKey}NAME_OU`)}
                  <i className={this.getSortIcon('organizedUnitId')} />
                </th>
                <th onClick={() => { this.changeOrder('saleTypeId') }}>
                  {t(`${tKey}NAME_SALE_TYPE`)}
                  <i className={this.getSortIcon('saleTypeId')} />
                </th>
                <th onClick={() => { this.changeOrder('operationTypeId') }}>
                  {t(`${tKey}NAME_TYPE_OPERATION`)}
                  <i className={this.getSortIcon('operationTypeId')} />
                </th>
                <th style={{ width: '77px' }}>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {organizedUnitSaleOperationList && organizedUnitSaleOperationList.map((operationType, idx) => {
                return (
                  <tr key={idx} className={operationType.isDeleted ? 'is-deleted' : ''}>
                    <td>{organizedUnitsAllCombo && organizedUnitsAllCombo.find(x => x.id === operationType?.organizedUnitId) && organizedUnitsAllCombo.find(x => x.id === operationType?.organizedUnitId).value}</td>
                    <td>{saleTypeAllCombo && saleTypeAllCombo.find(x => x.id === operationType?.saleTypeId) && saleTypeAllCombo.find(x => x.id === operationType?.saleTypeId).value}</td>
                    <td>{operationTypeAllCombo && operationTypeAllCombo.find(x => x.id === operationType?.operationTypeId) && operationTypeAllCombo.find(x => x.id === operationType?.operationTypeId).value}</td>
                    <td>
                      {!operationType.isDeleted && (
                        <div>
                          <a onClick={() => openOrganizedUnitSaleOperationModal(operationType)}>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <i className="ico-edit-white" />
                            </OverlayTrigger>
                          </a>
                          <a onClick={() => deleteOrganizedUnitSaleOperation(operationType.organizedUnitSaleOperationId)}>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <i className="ico-trash" />
                            </OverlayTrigger>
                          </a>
                        </div>
                      )}
                    </td>
                  </tr>)
              })
              }
              {(organizedUnitSaleOperationList === null || organizedUnitSaleOperationList === undefined || organizedUnitSaleOperationList.length === 0) &&
            <tr>
              <td colSpan={10}><h2>{t(`${tKey}RESULTS_NOT_FOUND`)}</h2></td>
            </tr>}
              <tr className="button-table-wrapper">
                <td>
                  <Button
                    className="btn-editable-table btn-standard"
                    onClick={() => openOrganizedUnitSaleOperationModal()}>
                  + {t(`${tKey}ADD`)}
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="section-users-footer">
            <nav key={1} className="text-center">
              <IDocCarPagination
                id="btn_pag_sales"
                page={page}
                pagesCount={pagesCount}
                totalRows={organizedUnitSaleOperationsCount}
                onSelectAction={(value) => fetchOrganizedUnitSaleOperationList({ ...filter, ...this.state.filter, page: value })}
              />
            </nav>
          </div>
        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listDocumentType'
})(OrganizedUnitSaleOperationMaster)
